module.exports = __webpack_public_path__ + "img/title-img.dd828764.png";